/**
 * Validates if a redirect URL is safe and properly formatted
 * @param url - The URL to validate
 * @returns true if valid or empty, false otherwise
 */
export const isValidRedirectUrl = (url: string): boolean => {
  if (!url || url.trim() === '') return true; // Empty is valid (will be cleared)

  try {
    const parsed = new URL(url);
    // Only allow http and https protocols
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false; // Invalid URL format
  }
};

/**
 * Gets a user-friendly error message for an invalid redirect URL
 * @param url - The URL to validate
 * @returns Error message string if invalid, null if valid
 */
export const getUrlValidationError = (url: string): string | null => {
  if (!url || url.trim() === '') return null;

  try {
    const parsed = new URL(url);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return `Only HTTP and HTTPS URLs are allowed. Protocol "${parsed.protocol}" is not permitted.`;
    }
    return null;
  } catch {
    return 'Please enter a valid URL (e.g., https://example.com/thank-you)';
  }
};
